import { Form, DatePicker, Button, message, Modal, Divider, Typography } from "antd";
import { useEffect, useState } from "react";
import AnimateItems from "../../../utils/AnimateItems";
import axios from "axios";
import { useAuth } from "../../../layout/auth";
import moment from "moment";
import "moment/locale/es";
moment.locale("es-mx");

export default function FechasForm(props) {
  const { title, visible, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [timeRange, setTimeRange] = useState();
  const [form] = Form.useForm();

  const auth = useAuth();

  useEffect(() => {
    if (visible && auth && auth.UID) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/usuarios/rango`, {
          params: { u: auth.UID },
        })
        .then((res) => {
          setTimeRange(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [auth, visible]);

  const disabledDates = () => {
    if (!timeRange || !timeRange[0]) {
      return () => false;
    }

    const today = moment();
    const startDate = today.clone().subtract(timeRange[0]?.DiasAntes || 0, "days");
    const endDate = today.clone().add(timeRange[0]?.DiasDespues || 0, "days");
    return (currentDate) => {
      return currentDate.isBefore(startDate, "day") || currentDate.isAfter(endDate, "day");
    };
  };

  useEffect(() => {
    form.setFieldsValue({
      FechaCreacion: moment(verification?.FechaCreacion, "YYYY-MM-DD").isValid() ? moment(verification?.FechaCreacion, "YYYY-MM-DD") : null,
      FechaRecepcion: moment(verification?.FechaRecepcion, "YYYY-MM-DD").isValid()
        ? moment(verification?.FechaRecepcion, "YYYY-MM-DD")
        : null,
      FechaContrato: moment(verification?.FechaContrato, "YYYY-MM-DD").isValid() ? moment(verification?.FechaContrato, "YYYY-MM-DD") : null,
      FechaListo: moment(verification?.FechaListo, "YYYY-MM-DD").isValid() ? moment(verification?.FechaListo, "YYYY-MM-DD") : null,
      FechaEmision: moment(verification?.FechaEmision, "YYYY-MM-DD").isValid() ? moment(verification?.FechaEmision, "YYYY-MM-DD") : null,
      FechaPago: moment(verification?.FechaPago, "YYYY-MM-DD").isValid() ? moment(verification?.FechaPago, "YYYY-MM-DD") : null,
      FechaPapeleria: moment(verification?.FechaPapeleria, "YYYY-MM-DD").isValid()
        ? moment(verification?.FechaPapeleria, "YYYY-MM-DD")
        : null,
      FechaCancelacion: moment(verification?.FechaCancelacion, "YYYY-MM-DD").isValid()
        ? moment(verification?.FechaCancelacion, "YYYY-MM-DD")
        : null,
    });
  }, [verification, form]);

  // Converts any moment values in the form to plain "YYYY-MM-DD" strings
  // before they're sent to the backend, avoiding the implicit UTC-ISO
  // serialization that raw moment objects go through in JSON.stringify.
  const formatDatesForSubmit = (values) => {
    return Object.fromEntries(
      Object.entries(values).map(([key, value]) => [key, moment.isMoment(value) ? value.format("YYYY-MM-DD") : value])
    );
  };

  return (
    <>
      <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800}>
        <Form form={form} layout="vertical">
          <AnimateItems delay={0.35}>
            <Form.Item name="FechaCreacion" label="Fecha de creación">
              <DatePicker
                disabled
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                disabledDate={(current) => current && current > moment().endOf("day")}
              />
            </Form.Item>
            <Form.Item name="FechaRecepcion" label="Fecha de la solicitud">
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                disabledDate={disabledDates()}
              />
            </Form.Item>
            <Form.Item name="FechaContrato" label="Fecha del contrato">
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                disabledDate={disabledDates()}
              />
            </Form.Item>

            {auth.Rol === "director" && (
              <>
                <Typography.Title type="secondary" level={5} style={{ textAlign: "center" }}>
                  Fechas del proceso
                </Typography.Title>
                <Form.Item name="FechaListo" label="Fecha en que el verificador marcó como listo">
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item name="FechaEmision" label="Fecha de emisión">
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item name="FechaPago" label="Fecha del pago">
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item name="FechaPapeleria" label="Fecha de entrega de papelería">
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item name="FechaCancelacion" label="Fecha de cancelación">
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </>
            )}
          </AnimateItems>
        </Form>
        <Button
          type="primary"
          onClick={() => {
            const formattedValues = formatDatesForSubmit(form.getFieldsValue());
            const verificationData = { ...verification, ...formattedValues };
            axios
              .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
              .then(() => {
                message.success("Campos actualizados correctamente");
                setVerification(verificationData);
                setVisible(false);
              })
              .catch((err) => {
                console.log(err);
                message.error("Error al actualizar los campos");
              });
          }}
        >
          Guardar
        </Button>
      </Modal>
    </>
  );
}